import { Request } from '../../request'
export default async () => Request( client => client.group.list.$get() )
